import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getFentraUsers = api(async function fentraUsers({ profileId } = {}) {
    return await query(
        gql`
            query fentraUsers($profileId: ID!) {
                fentraUsers(profileId: $profileId) {
                    _id
                    profileId
                    externalId
                    userName
                    email
                    displayName
                    givenName
                    familyName
                    jobTitle
                    active
                    provisionStatus
                }
            }
        `,
        { profileId },
        { returns: "fentraUsers" }
    )
})
